import { types } from './../types/types'
import { IAction, IState, IEntity } from './AuthInterface'

const defaultEntity: IEntity = {
    _id: '',
    entity_name: '',
    description: '',
    admin: '',
    domain: '',
    user: '',
    roles: {
        counter: false,
        admin: false,
        coordinador: false,
        estudiante: false,
        docente: false,
    },
    customize: {
        logo: '/images/login/playtec.svg',
        portrait: '',
        colors: { bg_sidebar: '#197BFF', bg_buttons: '#197BFF', font_color: '#ffffff' },
    },
}

export const authReducer = (state: IState, action: IAction): IState => {
    switch (action.type) {
        case types.login: {
            const payload = action.payload || {}
            return {
                ...state,
                ...payload,
                logged: true,
                token: payload.token ?? state.token ?? '',
                listEntity: payload.listEntity ?? state.listEntity ?? [],
                username: payload.username ?? state.username ?? '',
                rol: payload.rol ?? state.rol ?? '',
                idUser: payload.idUser ?? state.idUser ?? '',
                dataEntity: (payload.dataEntity as IEntity) ?? state.dataEntity ?? defaultEntity,
                platform: payload.platform ?? state.platform ?? { id: '', platform_name: '', alias: '', description: '' },
            }
        }

        case types.getRoles:
            return {
                ...state,
                rolesByEntity: action.payload,
            }

        case types.changeRoles:
            return {
                ...state,
                main_rol: action.payload,
            }

        case types.editUser:
            return {
                ...state,
                user: {
                    _id: action.payload?._id || '',
                    username: action.payload?.username || '',
                    email: action.payload?.email || '',
                    name: action.payload?.name || '',
                    lastname: action.payload?.lastname || '',
                    photo: action.payload?.photo || '',
                    phone: action.payload?.phone || '',
                    address: action.payload?.address || '',
                    dni: action.payload?.dni || '',
                    documentType: action.payload?.documentType || '',
                    rol: action.payload?.rol || state.user.rol || '',
                },
            }

        case types.editEntity:
            return {
                ...state,
                dataEntity: action.payload,
            }

        case types.logout:
            return {
                logged: false,
                user: {
                    _id: '',
                    username: '',
                    email: '',
                    name: '',
                    lastname: '',
                    photo: '',
                    phone: '',
                    address: '',
                    dni: '',
                    documentType: '',
                    rol: '',
                },
                rolesByEntity: { admin: false, coordinador: false, counter: false },
                listEntity: [],
                token: '',
                username: '',
                rol: '',
                idUser: '',
                dataEntity: defaultEntity,
                platform: { id: '', platform_name: '', alias: '', description: '' },
                main_rol: '',
            }

        default:
            return state
    }
}
